import { policyAllows } from './modules';
import type { Kind, Snapshot } from './types';

const common = ['workspace', 'task', 'message', 'search', 'help'];
const resources: Record<string, string[]> = {
  groupLeader: [...common, 'operation', 'pilot', 'knowledge', 'usage'],
  teacher: [
    ...common,
    'device',
    'recording',
    'analysis',
    'clue',
    'case',
    'correction',
    'teaching',
    'teacher',
    'plan',
    'knowledge',
    'ticket',
  ],
  deviceManager: [
    ...common,
    'device',
    'deviceModel',
    'inventory',
    'repair',
    'collection',
    'location',
    'ticket',
    'audit',
  ],
  reviewer: [
    ...common,
    'recording',
    'analysis',
    'clue',
    'case',
    'correction',
    'evaluation',
    'audit',
  ],
  researchLead: [
    ...common,
    'recording',
    'analysis',
    'analysisTemplate',
    'evaluation',
    'teaching',
    'teacher',
    'plan',
    'knowledge',
    'knowledgeReview',
  ],
  studentService: [
    ...common,
    'recording',
    'student',
    'service',
    'feedback',
    'ticket',
  ],
  systemAdmin: [
    ...common,
    'organization',
    'permission',
    'rule',
    'model',
    'integration',
    'dataPolicy',
    'audit',
    'subscription',
    'deviceModel',
  ],
  support: [...common, 'device', 'repair', 'ticket', 'audit'],
};
const kinds: Record<string, Kind> = {
  recording: 'recording',
  analysis: 'job',
  clue: 'clue',
  case: 'case',
  plan: 'plan',
  knowledge: 'knowledge',
  student: 'student',
  service: 'followUp',
  feedback: 'feedback',
  device: 'device',
  inventory: 'inventory',
  repair: 'repair',
  analysisTemplate: 'template',
  organization: 'organization',
  permission: 'policy',
  rule: 'rule',
  model: 'modelConfig',
  integration: 'integration',
  subscription: 'subscription',
  evaluation: 'evaluation',
};
export function canOpenResource(resource: string, state: Snapshot): boolean {
  const list = resources[state.context.role];
  if (list && !list.includes(resource)) return false;
  const kind = kinds[resource];
  return !kind || policyAllows(state, kind, 'read');
}
